module.exports = __webpack_public_path__ + "img/Hielera blanda tipo mochila M20.b46c4221.jpg";